export const RAG_DOCUMENTS_PATH = "/settings-menu/rag-documents";
